import { Grid } from '@mui/material';
import Select from "react-select";
import EntityListToolbar from '../subcomponents/EntityListToolbar';
import CUClassroom from "../CreateUpdateComponents/Classroom";


const ClassroomListToolbar = ({ updateGradeFilter, gradesOptions, updateSearch, loadData, readOnly, ...props }) => (
    <EntityListToolbar
        updateSearch={updateSearch}
        loadData={loadData}
        searchPlaceholder="Rechercher une classe"
        CreateComponent={CUClassroom}
        hideAddButton={readOnly}
        {...props}
    >
        <Grid item xs={12} md={12} lg={6}>
            <Select
                minMenuHeight={1000}
                placeholder="Niveaux..."
                isClearable={true}
                isSearchable={true}
                name="day"
                isMulti
                onChange={updateGradeFilter}
                options={gradesOptions}
                defaultValue={[]}
            />
        </Grid>
    </EntityListToolbar>
);

export default ClassroomListToolbar;
